/* ══════════════════════════════════════════════════════════
   MONTCLAIR — Interactividad
   Reemplaza la lógica de React por JS nativo + Cart AJAX API.
   ══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var MC = window.MontclairTheme || {};
  var money_format = MC.moneyFormat || '${{amount}}';
  var strings = MC.strings || {};

  /* ── Formato de precio, siguiendo el money_format de la tienda ── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, size) {
      return new Array(Math.max(size - String(num).length + 1, 0)).join('0') + num;
    }

    function thousands(number, precision, thousandSep, decimalSep) {
      thousandSep = thousandSep === undefined ? ',' : thousandSep;
      decimalSep = decimalSep === undefined ? '.' : decimalSep;
      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandSep);
      var cents_ = parts[1] ? decimalSep + parts[1] : '';
      return dollars + cents_;
    }

    var match = money_format.match(placeholderRegex);
    if (!match) return money_format;

    switch (match[1]) {
      case 'amount':
        value = thousands(cents, 2);
        break;
      case 'amount_no_decimals':
        value = thousands(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = thousands(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = thousands(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = thousands(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = thousands(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = thousands(cents, 2, "'", '.');
        break;
      default:
        value = thousands(cents, 2);
    }

    return money_format.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ══════════════════════════════════════
     Aviso emergente
     ══════════════════════════════════════ */
  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('mc-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('mc-visible');
    }, 2600);
  }

  /* ══════════════════════════════════════
     Cabecera: fondo sólido al hacer scroll
     ══════════════════════════════════════ */
  /* Publica la altura real de la cabecera para que la galería del
     producto se pegue justo debajo, sea cual sea el logo. */
  function syncHeaderHeight() {
    var header = $('[data-mc-header]');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--mc-header-h', h + 'px');
    }
  }

  function initHeader() {
    var header = $('[data-mc-header]');

    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight, { passive: true });

    if (!header || header.classList.contains('mc-header--static')) return;

    var ticking = false;

    function update() {
      var y = window.scrollY;
      header.classList.toggle('mc-header--solid', y >= 80);
      document.body.classList.toggle('mc-scrolled', y > 50);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  }

  /* ══════════════════════════════════════
     Desplegable de colecciones
     ══════════════════════════════════════ */
  function initDropdown() {
    var dd = $('[data-mc-dropdown]');
    if (!dd) return;

    var toggle = $('[data-mc-dropdown-toggle]', dd);
    if (!toggle) return;

    function close() {
      dd.classList.remove('mc-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dd.classList.toggle('mc-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ══════════════════════════════════════
     Menú móvil
     ══════════════════════════════════════ */
  function initMobileMenu() {
    var burger = $('[data-mc-burger]');
    var menu = $('[data-mc-mobile-menu]');
    if (!burger || !menu) return;

    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('mc-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });

    $$('a', menu).forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('mc-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ══════════════════════════════════════
     Animaciones al entrar en pantalla
     ══════════════════════════════════════ */
  function initReveals() {
    var els = $$('.mc-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('mc-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mc-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════
     Parallax suave
     ══════════════════════════════════════ */
  function initParallax() {
    var targets = $$('[data-mc-parallax]');
    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;

    function update() {
      var vh = window.innerHeight;

      targets.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-mc-parallax')) || 0.15;
        var host = el.parentElement;
        if (!host) return;

        var rect = host.getBoundingClientRect();

        /* Fuera de pantalla no hace falta recalcular */
        if (rect.bottom < 0 || rect.top > vh) return;

        /* El desplazamiento se mide contra la posición de la sección en
           pantalla, no contra el scroll total del documento: así vale 0
           cuando la sección está centrada y nunca deja el hueco que
           aparecía en las secciones bajas de la página. */
        var offset = rect.top + rect.height / 2 - vh / 2;
        el.style.transform = 'translateY(' + -offset * speed + 'px)';
      });

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ══════════════════════════════════════
     Acordeones
     ══════════════════════════════════════ */
  function initAccordions() {
    $$('[data-mc-acc]').forEach(function (acc) {
      var btn = $('[data-mc-acc-btn]', acc);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('mc-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ══════════════════════════════════════
     Galería del producto
     ══════════════════════════════════════ */
  function initGallery() {
    var gallery = $('[data-mc-gallery]');
    if (!gallery) return;

    var slides = $$('[data-mc-slide]', gallery);
    var thumbs = $$('[data-mc-thumb]', gallery);

    function show(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('mc-active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('mc-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        show(i);
      });
    });

    /* Al elegir una variante con imagen propia, saltamos a esa foto */
    document.addEventListener('mc:variant:change', function (e) {
      var mediaId = e.detail && e.detail.featuredMediaId;
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) {
        return s.getAttribute('data-media-id') === String(mediaId);
      });
      if (idx > -1) show(idx);
    });
  }

  /* ══════════════════════════════════════
     Selector de variantes (tallas)
     ══════════════════════════════════════ */
  function initVariantPickers() {
    $$('[data-mc-picker]').forEach(function (picker) {
      var variants;
      try {
        variants = JSON.parse(picker.getAttribute('data-variants') || '[]');
      } catch (err) {
        variants = [];
      }

      var buttons = $$('[data-mc-size]', picker);
      var select = $('[data-mc-variant-select]', picker);
      var cta = $('[data-mc-add]', picker);
      var hint = $('[data-mc-hint]', picker);
      var priceEl = $('[data-mc-live-price]', picker);
      var selected = null;

      function markReady() {
        if (!cta) return;
        cta.classList.add('mc-ready');
        cta.disabled = false;
        cta.textContent = strings.addToBag || 'Add to Bag';
      }

      /* Si sólo hay una variante sin opciones reales, la damos por elegida */
      if (variants.length === 1 && !buttons.length && !select) {
        selected = variants[0];
        markReady();
      }

      /* Aplica la variante elegida: precio, foto, URL y estado del botón */
      function select_variant(variant) {
        selected = variant || null;
        if (!selected) return;

        if (hint) hint.style.display = 'none';
        markReady();

        if (priceEl) priceEl.innerHTML = formatMoney(selected.price);

        document.dispatchEvent(
          new CustomEvent('mc:variant:change', {
            detail: { variant: selected, featuredMediaId: selected.featured_media_id }
          })
        );

        /* Mantiene la URL sincronizada con la variante elegida */
        if (picker.hasAttribute('data-update-url') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', selected.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      function findVariant(id) {
        return (
          variants.filter(function (v) {
            return String(v.id) === String(id);
          })[0] || null
        );
      }

      /* Desplegable, cuando el producto tiene dos o más opciones */
      if (select) {
        select.addEventListener('change', function () {
          if (!select.value) return;
          select_variant(findVariant(select.value));
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('mc-unavailable')) return;

          buttons.forEach(function (b) {
            b.classList.remove('mc-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('mc-active');
          btn.setAttribute('aria-pressed', 'true');

          select_variant(findVariant(btn.getAttribute('data-variant-id')));
        });
      });

      if (!cta) return;

      cta.addEventListener('click', function () {
        if (!selected) {
          if (hint) hint.style.display = 'block';
          toast(strings.selectSize || 'Please select a size');
          return;
        }
        if (cta.disabled) return;

        var original = cta.textContent;
        cta.disabled = true;
        cta.textContent = strings.adding || 'Adding…';

        Cart.add(selected.id, 1)
          .then(function () {
            cta.classList.add('mc-done');
            cta.textContent = strings.added || 'Added to Bag ✓';
            setTimeout(function () {
              cta.classList.remove('mc-done');
              cta.textContent = original;
              cta.disabled = false;
            }, 2200);
            Cart.open();
          })
          .catch(function (err) {
            cta.textContent = original;
            cta.disabled = false;
            toast(err.message || strings.error || 'Could not add to cart');
          });
      });
    });
  }

  /* ══════════════════════════════════════
     Carrito — Cart AJAX API de Shopify
     ══════════════════════════════════════ */
  var Cart = {
    routes: MC.routes || {},

    url: function (key, fallback) {
      return this.routes[key] || fallback;
    },

    open: function () {
      document.body.classList.add('mc-cart-open');
      document.body.style.overflow = 'hidden';
      var drawer = $('[data-mc-cart-drawer]');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'false');
        var closeBtn = $('[data-mc-cart-close]', drawer);
        if (closeBtn) closeBtn.focus();
      }
      this.refresh();
    },

    close: function () {
      document.body.classList.remove('mc-cart-open');
      document.body.style.overflow = '';
      var drawer = $('[data-mc-cart-drawer]');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    },

    add: function (variantId, quantity) {
      var self = this;
      return fetch(this.url('cartAdd', '/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw new Error(data.description || data.message || 'Error');
            }
            return data;
          });
        })
        .then(function (data) {
          return self.refresh().then(function () {
            return data;
          });
        });
    },

    change: function (line, quantity) {
      var self = this;
      return fetch(this.url('cartChange', '/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          self.render(cart);
          return cart;
        });
    },

    refresh: function () {
      var self = this;
      return fetch(this.url('cart', '/cart.js'), {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          self.render(cart);
          return cart;
        })
        .catch(function () {
          /* Sin conexión: dejamos el contenido que ya estaba */
        });
    },

    updateCount: function (count) {
      $$('[data-mc-cart-count]').forEach(function (el) {
        el.textContent = count > 9 ? '9+' : count;
        el.hidden = count === 0;
      });
      $$('[data-mc-cart-count-text]').forEach(function (el) {
        el.textContent = count > 0 ? '(' + count + ')' : '';
      });
    },

    render: function (cart) {
      this.updateCount(cart.item_count);

      var body = $('[data-mc-cart-body]');
      var foot = $('[data-mc-cart-foot]');
      var empty = $('[data-mc-cart-empty]');
      var pieces = $('[data-mc-cart-pieces]');

      if (pieces) {
        pieces.textContent =
          cart.item_count > 0
            ? cart.item_count + ' ' + (cart.item_count === 1 ? strings.piece || 'piece' : strings.pieces || 'pieces')
            : '';
      }

      if (cart.item_count === 0) {
        if (empty) empty.hidden = false;
        if (body) body.hidden = true;
        if (foot) foot.hidden = true;
        return;
      }

      if (empty) empty.hidden = true;
      if (body) body.hidden = false;
      if (foot) foot.hidden = false;

      if (body) {
        body.innerHTML = cart.items
          .map(function (item, i) {
            var img = item.image
              ? item.image.replace(/(\.[^.]*)$/, '_160x200_crop_center$1')
              : '';
            var variantLabel =
              item.variant_title && item.variant_title !== 'Default Title'
                ? escapeHtml(item.variant_title)
                : '';

            return (
              '<div class="mc-cart-item" data-line="' + (i + 1) + '">' +
              '<div class="mc-cart-item__media">' +
              (img
                ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="80" height="100">'
                : '<div style="width:80px;height:100px;background:#111"></div>') +
              '<span class="mc-corner"></span>' +
              '</div>' +
              '<div class="mc-cart-item__info">' +
              '<div>' +
              '<a href="' + escapeHtml(item.url) + '" class="mc-cart-item__name">' + escapeHtml(item.product_title) + '</a>' +
              (variantLabel ? '<p class="mc-cart-item__variant">' + variantLabel + '</p>' : '') +
              '</div>' +
              '<div class="mc-cart-item__foot">' +
              '<div class="mc-qty">' +
              '<button class="mc-qty__btn" data-mc-qty="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(strings.decrease || 'Decrease quantity') + '">−</button>' +
              '<span class="mc-qty__val">' + item.quantity + '</span>' +
              '<button class="mc-qty__btn" data-mc-qty="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(strings.increase || 'Increase quantity') + '">+</button>' +
              '</div>' +
              '<span class="mc-cart-item__price">' + formatMoney(item.line_price) + '</span>' +
              '</div>' +
              '<button class="mc-remove" data-mc-qty="' + (i + 1) + '" data-qty="0">' + escapeHtml(strings.remove || 'Remove') + '</button>' +
              '</div>' +
              '</div>'
            );
          })
          .join('');
      }

      var total = $('[data-mc-cart-total]');
      if (total) total.innerHTML = formatMoney(cart.total_price);
    },

    init: function () {
      var self = this;

      $$('[data-mc-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      $$('[data-mc-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.close();
        });
      });

      var overlay = $('[data-mc-cart-overlay]');
      if (overlay) {
        overlay.addEventListener('click', function () {
          self.close();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && document.body.classList.contains('mc-cart-open')) {
          self.close();
        }
      });

      /* Delegación: los botones se recrean en cada render */
      var body = $('[data-mc-cart-body]');
      if (body) {
        body.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-mc-qty]');
          if (!btn) return;
          e.preventDefault();
          var line = parseInt(btn.getAttribute('data-mc-qty'), 10);
          var qty = parseInt(btn.getAttribute('data-qty'), 10);
          if (isNaN(line) || isNaN(qty) || qty < 0) return;
          btn.disabled = true;
          self.change(line, qty).catch(function () {
            btn.disabled = false;
            toast(strings.error || 'Something went wrong');
          });
        });
      }

      /* Sincroniza al volver desde el caché del navegador */
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) self.refresh();
      });
    }
  };

  /* ══════════════════════════════════════
     Filtros de colección
     ══════════════════════════════════════ */
  function initFilters() {
    var bar = $('[data-mc-filters]');
    if (!bar) return;

    var buttons = $$('[data-mc-filter]', bar);
    var cards = $$('[data-mc-card]');
    var counter = $('[data-mc-filter-count]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-mc-filter');

        buttons.forEach(function (b) {
          b.classList.remove('mc-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('mc-active');
        btn.setAttribute('aria-pressed', 'true');

        var shown = 0;
        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          var type = (card.getAttribute('data-type') || '').toLowerCase();
          var match =
            value === 'all' ||
            tags.split('|').indexOf(value.toLowerCase()) > -1 ||
            type === value.toLowerCase();
          card.classList.toggle('mc-hidden', !match);
          if (match) shown++;
        });

        if (counter) {
          counter.textContent = shown + ' ' + (shown === 1 ? strings.piece || 'Piece' : strings.pieces || 'Pieces');
        }
      });
    });
  }

  /* ══════════════════════════════════════
     Barra de compra fija
     ══════════════════════════════════════ */
  function initStickyBuy() {
    var bar = $('[data-mc-sticky-buy]');
    var anchor = $('[data-mc-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('mc-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    var btn = $('[data-mc-sticky-add]', bar);
    if (btn) {
      btn.addEventListener('click', function () {
        var mainCta = $('[data-mc-add]');
        if (mainCta) {
          mainCta.click();
          if (!mainCta.classList.contains('mc-ready')) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }
  }

  /* ══════════════════════════════════════
     Codex — pestañas de cápsula
     ══════════════════════════════════════ */
  function initCapsules() {
    var tabsWrap = $('[data-mc-capsule-tabs]');
    if (!tabsWrap) return;

    var tabs = $$('[data-mc-capsule-tab]', tabsWrap);
    var panels = $$('[data-mc-capsule]');

    function show(index) {
      tabs.forEach(function (t, i) {
        t.classList.toggle('mc-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('mc-active', i === index);
      });

      /* El fondo del hero acompaña a la cápsula elegida */
      var hero = $('[data-mc-codex-hero]');
      if (hero) {
        var covers = $$('[data-mc-cover]', hero);
        covers.forEach(function (c, i) {
          c.style.opacity = i === index ? '1' : '0';
        });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        show(i);
      });
    });

    /* Permite llegar con enlace directo: /pages/codex#capsule-2 */
    var hash = window.location.hash.match(/^#capsule-(\d+)$/);
    show(hash ? Math.max(0, parseInt(hash[1], 10) - 1) : 0);
  }

  /* ══════════════════════════════════════
     Reproductor del episodio

     Con un audio real (metafield codex.audio) controla ese audio.
     Sin audio, reproduce la misma animación decorativa del diseño
     original — ahí el reproductor nunca fue funcional.
     ══════════════════════════════════════ */
  function initEpisodePlayer() {
    var player = $('[data-mc-ep-player]');
    if (!player) return;

    var btn = $('[data-mc-play]', player);
    var bar = $('[data-mc-progress]', player);
    var fill = $('[data-mc-progress-fill]', player);
    var knob = $('[data-mc-progress-knob]', player);
    var elapsedEl = $('[data-mc-elapsed]', player);
    var remainingEl = $('[data-mc-remaining]', player);
    var bars = $$('[data-mc-wave-bar]', player);
    var audio = $('[data-mc-audio]', player);

    /* Duración declarada en el metafield, en minutos, como respaldo */
    var fallbackMinutes = parseInt(player.getAttribute('data-duration'), 10) || 20;
    var progress = 0;
    var timer = null;

    function fmt(totalSeconds) {
      var m = Math.floor(totalSeconds / 60);
      var s = Math.floor(totalSeconds % 60);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }

    function totalSeconds() {
      if (audio && isFinite(audio.duration) && audio.duration > 0) return audio.duration;
      return fallbackMinutes * 60;
    }

    function paint() {
      var pct = Math.max(0, Math.min(100, progress));
      if (fill) fill.style.width = pct + '%';
      if (knob) knob.style.left = pct + '%';

      bars.forEach(function (b, i) {
        b.classList.toggle('mc-past', (i / bars.length) * 100 < pct);
      });

      var total = totalSeconds();
      var elapsed = (pct / 100) * total;
      if (elapsedEl) elapsedEl.textContent = fmt(elapsed);
      if (remainingEl) remainingEl.textContent = '-' + fmt(Math.max(0, total - elapsed));
    }

    function stopTicker() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function setPlaying(on) {
      player.classList.toggle('mc-playing', on);
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Pause' : 'Play');
      }
    }

    function play() {
      if (audio) {
        audio.play().catch(function () {
          /* Autoplay bloqueado o fichero ausente: seguimos sin audio */
        });
        setPlaying(true);
        return;
      }
      /* Sin audio: avance simulado, como el original */
      setPlaying(true);
      stopTicker();
      timer = setInterval(function () {
        progress += 0.25;
        if (progress >= 100) {
          progress = 0;
          pause();
        }
        paint();
      }, 300);
    }

    function pause() {
      if (audio) audio.pause();
      setPlaying(false);
      stopTicker();
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (player.classList.contains('mc-playing')) pause();
        else play();
      });
    }

    if (audio) {
      audio.addEventListener('timeupdate', function () {
        if (audio.duration > 0) {
          progress = (audio.currentTime / audio.duration) * 100;
          paint();
        }
      });
      audio.addEventListener('ended', function () {
        progress = 0;
        paint();
        setPlaying(false);
      });
      audio.addEventListener('loadedmetadata', paint);
    }

    /* Clic en la barra para saltar */
    if (bar) {
      bar.addEventListener('click', function (e) {
        var rect = bar.getBoundingClientRect();
        progress = ((e.clientX - rect.left) / rect.width) * 100;
        progress = Math.max(0, Math.min(100, progress));
        if (audio && audio.duration > 0) audio.currentTime = (progress / 100) * audio.duration;
        paint();
      });
    }

    paint();
  }

  /* ══════════════════════════════════════
     Barra de progreso de lectura
     ══════════════════════════════════════ */
  function initReadProgress() {
    var fill = $('[data-mc-read-progress]');
    if (!fill) return;

    var ticking = false;

    function update() {
      var docH = document.body.scrollHeight - window.innerHeight;
      var pct = docH > 0 ? Math.min(100, (window.scrollY / docH) * 100) : 0;
      fill.style.width = pct + '%';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  }

  /* ══════════════════════════════════════
     Arranque
     ══════════════════════════════════════ */
  function init() {
    document.body.classList.add('mc-body');

    initHeader();
    initDropdown();
    initMobileMenu();
    initReveals();
    initParallax();
    initAccordions();
    initGallery();
    initVariantPickers();
    initFilters();
    initStickyBuy();
    initCapsules();
    initEpisodePlayer();
    initReadProgress();
    Cart.init();

    /* Dispara la entrada escalonada del hero */
    setTimeout(function () {
      document.body.classList.add('mc-loaded');
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expuesto para las secciones y para el editor de temas */
  window.MontclairCart = Cart;
  window.MontclairToast = toast;

  document.addEventListener('shopify:section:load', init);
})();
